import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";

const DeleteConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  title,
  bodyText,
  confirmButtonText,
  cancelButtonText,
}) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ padding: 15 }}>{bodyText}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {cancelButtonText}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  bodyText: PropTypes.string,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
};

export default DeleteConfirmationModal;
